import { fixLocale } from '@data/page';
import { ReactNode } from 'react';
import styled from 'styled-components';

export interface DatesProps {
  startDate: string;
  endDate?: string;
  showTime?: boolean;
  showTimeZone?: boolean;
  dashSeparated?: boolean;
  className?: string;
  locale?: string;
  variant?: boolean;
}

/*** STYLING ***/

const Wrapper = styled.div``;

const DateSpan = styled.span``;

export const Dates = ({
  startDate,
  endDate,
  showTime,
  showTimeZone,
  dashSeparated,
  className,
  locale,
  variant,
}: DatesProps) => {
  //get locale from props, else use default "en-US"
  const localeString = fixLocale(locale) || 'en-US';

  const renderDateString = (dateIsoString: string): ReactNode => {
    if (!dateIsoString) return null;
    const dateObj = dateIsoString
      ? new Date(
          dateIsoString.match(/T.+/) ? dateIsoString : `${dateIsoString}`, // EST Eastern Standard Time
        ) // This regex ensures the correct date renders. Also won't break Safari.
      : new Date();
    let dateStr = dateObj.toLocaleDateString(
      localeString,
      variant
        ? {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
          }
        : {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          },
    );
    const time = dateObj.toLocaleTimeString(localeString, {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });

    return (
      <DateSpan>
        {dateStr}{' '}
        {showTime && time && (
          <>
            <span>at</span> {time}
          </>
        )}
      </DateSpan>
    );
  };
  return (
    <Wrapper className={className}>
      {renderDateString(startDate)}
      {endDate && (
        <span>
          {' '}
          {dashSeparated ? '-' : 'to'} {renderDateString(endDate)}{' '}
        </span>
      )}
      {showTime && showTimeZone && 'Eastern'}
    </Wrapper>
  );
};
